import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../dto/dto.js';
import { LocalizedPhotoReference } from './localized-photo-reference.js';
import { LocalizedString } from './localized-string.js';

export class ProfilePageLink extends DataModel {
  static readonly TYPE_ID: string = '3b2e1fb49a104402b96e97fbd6f6f2e1';

  constructor(
    // Web route of the Profile Page
    public readonly webRoute: string,
    public readonly names: LocalizedString,
    public readonly photos: LocalizedPhotoReference,
  ) {
    super();
  }

  get $typeId(): string {
    return ProfilePageLink.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProfilePageLink {
    return new ProfilePageLink(
        MapUtils.get<string>(map, 'webRoute'),
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'names')),
        context.fromData<LocalizedPhotoReference>(MapUtils.get<SerializedData>(map, 'photos')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'webRoute': this.webRoute,
      'names': context.toData(this.names),
      'photos': context.toData(this.photos),
    };
  }

  clone(): this {
    return new ProfilePageLink(
        this.webRoute,
        this.names.clone(),
        this.photos.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.webRoute === this.webRoute &&
      isSameData(other.names, this.names) &&
      isSameData(other.photos, this.photos);
  }
}

export class ProfilePageLinkBuilder extends DataModelBuilder<ProfilePageLink> {
  build(context: SerializationContext, map: SerializedData): ProfilePageLink {
    return ProfilePageLink.fromMap(context, map);
  }
}
